import React from 'react'

import { CrossClientQueryResultCellProps } from './types'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { CrossClientResultMatch } from '../Details/CrossClientResultMatch'

interface CrossClientQueryResultMatchCellProps extends CrossClientQueryResultCellProps {
  onShowDetails: () => void
}

export const CrossClientQueryResultMatchCell: React.FC<CrossClientQueryResultMatchCellProps> = ({ result, onShowDetails }) => {
  const { match } = result

  return (
    <div className='zocks-py-0.75 flex-1'>
      <div className='d-flex'>
        {match ? (
          <Tooltip className='zocks-text-gray-500' placement='top' title='View match details'>
            <CrossClientResultMatch match={match} onClick={onShowDetails} />
          </Tooltip>
        ) : (
          <div className='d-flex align-items-center text-nowrap px-2 py-1 gap-2 cross-client-match border border-1 zocks-border-0.5 zocks-border-color-gray-300 bg-white'>
            <span className='cross-client-incomplete-icon' aria-hidden='true' />
            <div className='paragraph-small medium zocks-text-gray-600'>Incomplete</div>
          </div>
        )}
      </div>
    </div>
  )
}
